export const SET_CONSEQUENCES = 'SET_CONSEQUENCES';

export const setConsequences = (consequences) => ({
    type: SET_CONSEQUENCES, consequences
});
